import React from 'react';

import {
  Box,
  Button,
  styled,
  Typography
} from '@mui/material';
import _ from 'lodash';
import {
  baseTypes,
  DownloadableResourceBox,
  legalDocumentsDataService,
  routeDirectory
} from 'modules';



const HeaderBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(2)
}));

const DocumentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%'
}));


interface IProps {
  apiFileData: baseTypes.IApiFileData[]
}

export const FC: React.FC<IProps> = props => {
  const getApiFileData = React.useCallback((title: legalDocumentsDataService.LegalDocument) => {
    return _.find(props.apiFileData, data => data.title === title);
  }, [props.apiFileData]);



  return (
    <Box>
      <HeaderBox display="flex" justifyContent="space-between">
        <Typography variant="h2">
          Template Legal Documents
        </Typography>

        <Button
          variant="text"
          color="primary"
          href={routeDirectory.legal.documents.path()}>
          SEE ALL
        </Button>
      </HeaderBox>

      <DocumentBox>
        <DownloadableResourceBox.FC
          title="Certificate of Incorporation"
          description={(
            <Typography>
                The Certificate of Incorporation (COI) or charter establishes the rights, preferences, privileges, and restrictions of each class and series of a Corporation's stock.
            </Typography>
          )}
          thumbnailFilename="legal_certificate_of_incorporation.png"
          apiFileData={getApiFileData('Certificate of Incorporation')}
          height={240}
          layoutVariant="document" />

        <DownloadableResourceBox.FC
          title="Stock Purchase Agreement"
          description={<Typography>The Stock Purchase Agreement sets forth the basic terms of the purchase and sale of the preferred stock to the investors (such as the purchase price, closing date, conditions to closing) and identifies the other financing documents.</Typography>}
          thumbnailFilename="legal_stock_purchase_agreement.png"
          apiFileData={getApiFileData('Stock Purchase Agreement')}
          height={240}
          layoutVariant="document" />

        <DownloadableResourceBox.FC
          title="Investors' Rights Agreement"
          description={<Typography>The Investors' Rights Agreement (IRA) covers information rights, registration rights, contractual “rights of first offer” or “preemptive” rights, and various post-closing covenants of the Company.</Typography>}
          thumbnailFilename="legal_investor_rights_agreement.png"
          apiFileData={getApiFileData('Investors\' Rights Agreement')}
          height={240}
          layoutVariant="document" />
      </DocumentBox>
    </Box>
  );
};
